import { Controller } from "@hotwired/stimulus";

// Manages the "X new requests available" notification banner
// on the webhook requests index page. When the user has active
// filters/search/pagination, new incoming requests show as a
// notification rather than live-updating the table.
export default class extends Controller {
  static targets = ["banner", "count"];
  static values = {
    defaultView: Boolean,
    newCount: { type: Number, default: 0 },
  };

  connect() {
    // Listen for Turbo Stream events that signal new requests
    this.handleTurboStream = this.handleTurboStream.bind(this);
    document.addEventListener(
      "turbo:before-stream-render",
      this.handleTurboStream
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-stream-render",
      this.handleTurboStream
    );
  }

  handleTurboStream(event) {
    const streamElement = event.detail?.newStream || event.target;
    if (!streamElement) return;

    // Check if this is a new-request-notification stream action
    const target = streamElement.getAttribute("target");
    if (target === "new-requests-counter") {
      // If the user is on default view, let the normal page handle it
      if (this.defaultViewValue) return;

      // Otherwise, increment our counter and show the banner
      event.preventDefault();
      this.newCountValue++;
      this.showBanner();
    }
  }

  newCountValueChanged() {
    if (this.hasCountTarget && this.newCountValue > 0) {
      const label =
        this.newCountValue === 1
          ? "1 new request"
          : `${this.newCountValue} new requests`;
      this.countTarget.textContent = label;
    }
  }

  showBanner() {
    if (this.hasBannerTarget) {
      this.bannerTarget.classList.remove("hidden");
    }
  }

  refresh() {
    // Reload the current page to show new requests
    window.location.reload();
  }
}
